@if (!embedded) {
<div class="modal-header justify-content-between">
  <h4 class="modal-title header-5">
    {{ configs.title }}
  </h4>
  <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="dismiss()"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
</div>
}

<div class="modal-body" [class.embedded-body]="embedded">
  <!-- Formly-managed fields (Connection Name, Type, Target Asset, S3 fields) -->
  <form [formGroup]="dynamicForm">
    <formly-form
      [model]="model"
      [fields]="fields"
      [options]="options"
      [form]="dynamicForm"
    ></formly-form>
  </form>

  <!-- ── File upload drop zone (local type only) ──────────────────── -->
  <ng-container *ngIf="showDropZone">
    <input
      #fileInputRef
      type="file"
      [attr.accept]="fileAccept"
      class="sc-hidden-file-input"
      (change)="onFileSelected($event)"
    />

    <label class="form-label">Upload file<span>*</span></label>
    <div class="sc-drop-zone-overlay" (click)="triggerFileInput()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="#5f2cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="17 8 12 3 7 8"/>
        <line x1="12" y1="3" x2="12" y2="15"/>
      </svg>
      <p class="sc-drop-hint">
        Drag &amp; drop your file here or
        <span class="sc-choose-file" (click)="$event.stopPropagation(); triggerFileInput()">Choose file</span>
      </p>
      <span class="sc-selected-file" *ngIf="selectedFile">{{ selectedFile.name }}</span>
      <span class="sc-file-hint" *ngIf="!fileError && model.targetAsset && fileAcceptHint">
        Allowed: {{ fileAcceptHint }}
      </span>
      <span class="sc-file-error" *ngIf="fileError">{{ fileError }}</span>
    </div>
  </ng-container>
</div>

<div class="modal-footer" *ngIf="!hideFooter">
  <button
    class="btn-accello-secondary mx-2"
    (click)="dismiss()"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn-accello-primary-light"
    [disabled]="!canSubmit"
    (click)="onSubmit()"
  >
    {{ configs.saveBtnText }}
  </button>
</div>
